import moment from 'moment';
import 'moment-timezone';

/**
 * Convert a UTC ISO string into the user's local timezone and format it.
 * Consolidates the returnInTZ helper that was duplicated across 10 components.
 *
 * @param {string} utcDate - UTC ISO string (e.g. new Date().toISOString() or a server timestamp).
 * @param {string} format - Moment format (default 'YYYY-MM-DD').
 */
export const returnInTZ = (utcDate, format = 'YYYY-MM-DD') => {
  const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment.utc(utcDate).tz(userTZ).format(format);
};

export const todayInTZ = (format = 'YYYY-MM-DD') =>
  returnInTZ(new Date().toISOString(), format);
